import { GPSPosition } from "../GPS-position";
import { EIMLTypeSubstratMineral } from "./enum/type-substrat-mineral"
import { EIMLTypeSubstratVegetal } from "./enum/type-substrat-vegetal"

export class Substrat {
    Code: string;
    MineralPreleve: EIMLTypeSubstratMineral;
    MineralAccompagnant: EIMLTypeSubstratMineral;
    Veg1: EIMLTypeSubstratVegetal;
    Veg2: EIMLTypeSubstratVegetal;
    Veg3: EIMLTypeSubstratVegetal;
    CoherenceGPS: boolean;
    Profondeur: number;
    DistanceBerge: number;
    Commentaire: string;
    GPSPosition: GPSPosition = new GPSPosition();
    RecouvrementCharli: number;

    static mapFromJSON(json: any): Substrat {
        const s = new Substrat();

        s.Code = json.code;
        s.MineralPreleve = json.mineralPreleve;
        s.MineralAccompagnant = json.mineralAccompagnant;
        s.Veg1 = json.veg1;
        s.Veg2 = json.veg2;
        s.Veg3 = json.veg3;
        s.CoherenceGPS = json.coherenceGps;
        s.Profondeur = json.profondeur;
        s.DistanceBerge = json.distanceBerge;
        s.Commentaire = json.commentaire;
        s.RecouvrementCharli = json.recouvrementCharli;

        if (json.gpsPosition) {
            s.GPSPosition = GPSPosition.mapFromJSON(json.gpsPosition);
        }

        return s;
    }
}